import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from "../../services/alert.service";
import { ToastrService } from "ngx-toastr";
import { logbaseService } from "../../services/logbase.service";
//import { forEach } from "@angular/router/src/utils/collection";
import { NgxSpinnerService } from "ngx-spinner";
import { EqualValidator } from "./../../directives/equal-validator.directive";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"]
})
export class RegistrationComponent implements OnInit {
  npdprequired: boolean = true;
  opTypeRequired: boolean = true;
  supplierCodeReqFlag;
  deliveryPointlink = [];
  opSupplierCodelink = [];
  rolesModelArray = [];
  roleArray = [];
  supplierError: boolean;
  selectedSupplier: any;
  supplierCode: any;
  supplierLoginId: void;
  displayUntagAlert: boolean;
  supplierData: any;
  valueSelected: any;
  packagingPropertyOptMultiSelect = [];
  settingsoperation: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    allowSearchFilter: Boolean,
    unSelectAllText: string;
    enableSearchFilter: boolean;
    searchBy: string[];
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  settingsDeliveryPoint: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    searchBy: string[];
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  emailPattern: string;
  phonePattern: any;
  userIDTakenEmail: boolean;
  settingsGroupNumber: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  settingsOperations: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  settingsLogistics: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  settingsSMVS: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  settingsGroupNumbers: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  operationsList: any[];
  logisticsList: any[];
  SMVSList: any[];
  operationsUsers: any;
  LogisticsUsers: any;
  SMVSUsers: any;
  l4Selected: boolean = false;
  SMQList: any;
  operationsGNumberList;
  settingsSMQ: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
    idField: string;
    textField: string;
  };
  SMQUsers: any;
  L4UserList: any;
  LineN: boolean;
  Suppc: boolean;
  operationDropdown: boolean;
  delPointSuppCodeDropdown: boolean;
  operationGNoDropdown: boolean;
  groupNumberDropdown: boolean;
  multiselectDropdown: boolean;
  suppliercodeDropdown: boolean;
  operationTypeDropdown: boolean;
  // operationTypes = ["Supplier To Supplier", "Fuso Operations"];
  operationTypes = [
    { displayName: "Supplier To Supplier", value: "suppliertosupplier" },
    { displayName: "Fuso Operations", value: "fusooperations" }
  ];
  operationType: string;
  userIDTaken: boolean;
  suppCodeVal: any;
  userDetails = localStorage.getItem("userDetails");
  userDetJson = JSON.parse(this.userDetails);
  userRoleID = this.userDetJson.userRoleMappings[0].roleId;
  itemSelected: any = [];
  operationSupplierCodeSelection = [];
  itemSelectedOperation: any = [];
  itemSelectedDeliveryPoint: any = [];
  itemSelectedGroupNumber: any = [];
  itemSelectedSMQ: any = [];
  itemSelectedSMVS: any = [];
  itemSelectedLogistics: any = [];
  itemsSelectedOperations: any = [];
  settingsroles;
  settings: {
    idField: string;
    textField: string;
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // classes: string;
    itemsShowLimit: number;
  };
  settingsSupplierCode: {
    idField: string;
    textField: string;
    singleSelection: boolean;
    allowSearchFilter: Boolean,
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    // // classes: string;
    itemsShowLimit: number;
  };
  settings2: {
    idField: string;
    textField: string;
    singleSelection: boolean;
    text: string;
    enableSearchFilter: boolean;
  };
  selectedItems: {}[];
  itemList: { id: number; itemName: string }[];
  roleName: any;
  roleId: any;
  system: any;
  getSupplierCode: any;
  supplierCodes: any;
  lineCodes: any;
  deliveryPointsraw: any;
  suppCodeList: any;
  lineCodeList: any;
  deliveryPointList: any;
  groupNumberList: any;
  packagingPropertyOpt: string[];

  model: any = {};
  loading = false;
  suppliercode: any = [];
  unamePattern = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{10,})"
  );
  SMQMod: any;
  getLineListbyGroupNo: any;
  showMatch: any;
  constructor(
    private router: Router,
    private userService: logbaseService,
    private toastr: ToastrService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";
    this.phonePattern = "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]{1,12}$";
    this.suppliercodeDropdown = true;
    this.multiselectDropdown = true;
    this.operationDropdown = true;
    this.delPointSuppCodeDropdown = true;
    this.operationGNoDropdown = true;
    this.groupNumberDropdown = true;
    this.operationTypeDropdown = true;
    this.spinner.show();
    if (this.userRoleID == 8) {
      this.packagingPropertyOpt = ["Supplier", "SMQ", "SMVS", "Reader"];
      var packagingPropertyOptions = [];
      this.packagingPropertyOpt.forEach(function(value, key) {
        packagingPropertyOptions.push({
          id: key + 1,
          itemName: value
        });
      });
      this.packagingPropertyOptMultiSelect = packagingPropertyOptions;
    } else if (this.userRoleID == 9) {
      this.packagingPropertyOpt = [
        "Logistic",
        "Assembly Operator",
        "Operation",
        "LSP",
        "Reader"
      ];

      var packagingPropertyOptions = [];
      this.packagingPropertyOpt.forEach(function(value, key) {
        packagingPropertyOptions.push({
          id: key + 1,
          itemName: value
        });
      });
      this.packagingPropertyOptMultiSelect = packagingPropertyOptions;
    } else if (this.userRoleID == 5) {
      this.packagingPropertyOpt = [
        "Supplier",
        "SMQ",
        "Logistic",
        "Operation",
        "Admin",
        "SMVS",
        "SM Admin",
        "Logistic Admin",
        "Assembly Operator",
        // "Line Worker",
        // "Level-4 Manager",
        "LSP",
        "Reader"
      ];
      var packagingPropertyOptions = [];
      this.packagingPropertyOpt.forEach(function(value, key) {
        packagingPropertyOptions.push({
          id: key + 1,
          itemName: value
        });
      });
      this.packagingPropertyOptMultiSelect = packagingPropertyOptions;
    }
    this.operationsGNumberList = [
      { id: 0, itemName: "HO (Higashi Ogishima)" },
      { id: 1, itemName: "K1" }
    ];
    this.userService.getSupplierMasterData().subscribe(result => {
      this.supplierCodes = result.response;
      let suppCodeListArr = [];
      this.supplierCodes.forEach(function(value, key) {
        suppCodeListArr.push({ id: key + 1, itemName: value.supplierCode });
      });

      this.suppCodeList = suppCodeListArr.sort(this.dynamicSort("itemName"));
      this.spinner.hide();
    });
    this.userService.getLineNumbers().subscribe(result => {
      this.lineCodes = result.response;
      let lineCodeListArr = [];
      this.lineCodes.forEach(function(value, key) {
        lineCodeListArr.push({ id: key + 1, itemName: value.lineNumber });
      });

      this.lineCodeList = lineCodeListArr;
      this.spinner.hide();
    });
    this.userService.getDeliveryPoints().subscribe(result => {
      this.deliveryPointsraw = result.response;
      let deliveryPointArr = [];
      this.deliveryPointsraw.forEach(function(value, key) {
        deliveryPointArr.push({ id: key + 1, itemName: value.deliveryPoint });
      });

      this.deliveryPointList = deliveryPointArr;
      this.spinner.hide();
    });
    this.userService.registerL4Users().subscribe(result => {
      this.L4UserList = result.response;
      this.SMQUsers = this.L4UserList.SMQ;
      this.SMVSUsers = this.L4UserList.SMVS;
      this.LogisticsUsers = this.L4UserList.LOGISTICS;
      this.operationsUsers = this.L4UserList.OPERATION;
      let SMQUserArray = [];
      let SMVSUserArray = [];
      let LogisticArray = [];
      let OperationArray = [];

      // {loginId: "smq12", firstName: "smq", lastName: "g"}

      this.SMQUsers.forEach(function(value, key) {
        SMQUserArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.firstName,
          lastName: value.lastName
        });
      });
      this.SMVSUsers.forEach(function(value, key) {
        SMVSUserArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.firstName,
          lastName: value.lastName
        });
      });
      this.LogisticsUsers.forEach(function(value, key) {
        LogisticArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.firstName,
          lastName: value.lastName
        });
      });
      this.operationsUsers.forEach(function(value, key) {
        OperationArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.firstName,
          lastName: value.lastName
        });
      });

      //Get Group Number master data
      /* this.userService.getGroupNumberMasterData().subscribe(result => {
        this.groupNumberList = result.response;
        let groupNumberListArray = [];
        this.groupNumberList.forEach(function (value, key) {
          groupNumberListArray.push({
            id: key + 1,
            itemName: value.groupNumber

          });
        });
        this.groupNumberList = groupNumberListArray;
        this.spinner.hide();
      });*/

      this.SMQList = SMQUserArray;
      this.SMVSList = SMVSUserArray;
      this.logisticsList = LogisticArray;
      this.operationsList = OperationArray;
    });
    this.selectedItems = [];
    this.settings = {
      singleSelection: false,
      text: this.translate.instant("Select Supplier Code"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsSupplierCode = {
      singleSelection: false,
      text: this.translate.instant("Select OM Supplier Code"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      allowSearchFilter: true,
      enableSearchFilter: true,
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsroles = {
      singleSelection: false,
      text: this.translate.instant("Select Required Roles"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsoperation = {
      singleSelection: false,
      text: this.translate.instant("Select Next Process"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      allowSearchFilter:true,
      enableSearchFilter: true,
      searchBy: ["itemName"],
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsDeliveryPoint = {
      singleSelection: false,
      text: this.translate.instant("Select Delivery Point"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      searchBy: ["itemName"],
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settings2 = {
      singleSelection: true,
      text: this.translate.instant("Select Supplier Code"),
      enableSearchFilter: true,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsSMQ = {
      singleSelection: false,
      text: this.translate.instant("Select SMQ"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
//        classes: "registerMultiSelect",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsSMVS = {
      singleSelection: false,
      text: this.translate.instant("Select SMVS"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
//        classes: "registerMultiSelect",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsLogistics = {
      singleSelection: false,
      text: this.translate.instant("Select Logistics"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
//        classes: "registerMultiSelect",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsOperations = {
      singleSelection: false,
      text: this.translate.instant("Select Operations Managers"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
//        classes: "registerMultiSelect",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsGroupNumber = {
      singleSelection: false,
      text: this.translate.instant("Select Group number"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.settingsGroupNumbers = {
      singleSelection: false,
      text: "Select Group Id",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
     //  classes: "custom-class",
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };

    if (
      (this.model.SMQMod != undefined && this.model.SMQMod.length > 0) ||
      (this.model.SMVSMod != undefined && this.model.SMVSMod.length > 0) ||
      (this.model.LogisticMod != undefined &&
        this.model.LogisticMod.length > 0) ||
      (this.model.operationMod != undefined &&
        this.model.operationMod.length > 0)
    ) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }

    if (JSON.parse(localStorage.getItem("cacheUser")) != undefined) {
      let cachevalue = JSON.parse(localStorage.getItem("cacheUser"));
      this.model.userrolemapping = cachevalue.role;
      // this.model.suppliercode = cachevalue.suppliercode;
      this.model.SMQMod = [];
      (this.model.suppliercode =
        cachevalue.suppliercode != null &&
        cachevalue.suppliercode != undefined &&
        cachevalue.suppliercode.length > 0
          ? cachevalue.suppliercode
          : []),
        (this.model.lineNumbers =
          cachevalue.lineNumbers != null &&
          cachevalue.lineNumbers != undefined &&
          cachevalue.lineNumbers.length > 0
            ? cachevalue.lineNumbers
            : []),
        (this.model.LogisticMod =
          cachevalue.Logistics != null &&
          cachevalue.Logistics != undefined &&
          cachevalue.Logistics.length > 0
            ? cachevalue.Logistics
            : []),
        (this.model.operationMod =
          cachevalue.Operations != null &&
          cachevalue.Operations != undefined &&
          cachevalue.Operations.length > 0
            ? cachevalue.Operations
            : []),
        (this.model.SMQMod =
          cachevalue.SMQ != null &&
          cachevalue.SMQ != undefined &&
          cachevalue.SMQ.length > 0
            ? cachevalue.SMQ
            : []),
        (this.model.SMVSMod =
          cachevalue.SMVS != null &&
          cachevalue.SMVS != undefined &&
          cachevalue.SMVS.length > 0
            ? cachevalue.SMVS
            : []);

      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedSMQ = [];
      this.itemSelectedSMVS = [];
      this.itemsSelectedOperations = [];
      this.itemSelectedLogistics = [];
      if (this.model.suppliercode.length > 0) {
        this.model.suppliercode.forEach(element => {
          this.itemSelected.push(element.itemName);
        });
      }
      if (this.model.lineNumbers.length > 0) {
        this.model.lineNumbers.forEach(element => {
          this.itemSelectedOperation.push(element.itemName);
        });
      }

      if (this.model.SMQMod.length > 0) {
        this.model.SMQMod.forEach(element => {
          this.itemSelectedSMQ.push(element.itemName);
        });
      }

      if (this.model.SMVSMod.length > 0) {
        this.model.SMVSMod.forEach(element => {
          this.itemSelectedSMVS.push(element.itemName);
        });
      }

      if (this.model.operationMod.length > 0) {
        this.model.operationMod.forEach(element => {
          this.itemsSelectedOperations.push(element.itemName);
        });
      }

      if (this.model.LogisticMod.length > 0) {
        this.model.LogisticMod.forEach(element => {
          this.itemSelectedLogistics.push(element.itemName);
        });
      }

      if (this.model.userrolemapping === "l4Manager") {
        this.model.userrolemapping = "Level-4 Manager";
        this.itemSelected = [];
        this.l4Selected = true;
      }
      this.callType(this.model.userrolemapping);
    }
  }

  onSingleSelectOperation(yes: any) {
    if (!this.roleArray.includes("Assembly Operator")) {
      this.deliveryPointlink = [];
      this.itemSelectedDeliveryPoint = [];
    }
    // this.itemSelectedOperation = [];
    this.itemSelectedOperation.push({ lineNumber: yes.itemName });
    this.npdprequired = false;
  }
  onDeSelectOperation(yes: any) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedOperation.indexOf({
      lineNumber: yes.itemName
    });
    this.itemSelectedOperation.splice(index, 1);
    let items = [];
    items = this.itemSelectedOperation;
    if (items.length == 0) this.npdprequired = true;
    if (this.operationType === this.operationTypes[0].value)
      this.npdprequired = false;
  }

  onSingleSelectDeliveyPoint(yes: any) {
    if (!this.roleArray.includes("Assembly Operator")) {
      this.model.lineNumbers = [];
      this.itemSelectedOperation = [];
    }
    // this.itemSelectedOperation = [];
    this.itemSelectedDeliveryPoint.push({ deliveryPoint: yes.itemName });
    this.npdprequired = false;
  }
  onDeSelectDeliveryPoint(yes: any) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedOperation.indexOf({
      deliveryPoint: yes.itemName
    });
    this.itemSelectedDeliveryPoint.splice(index, 1);
    let items = [];
    items = this.itemSelectedDeliveryPoint;
    if (items.length == 0) this.npdprequired = true;
    if (this.operationType === this.operationTypes[0].value)
      this.npdprequired = false;
  }

  onSingleSelectOperationSupplierCode(yes: any) {
    // this.itemSelectedOperation = [];
    this.operationSupplierCodeSelection.push({
      supplierCode: yes.itemName,
      isOperationManager: true
    });
  }
  onDeSelectOperationSupplierCode(yes: any) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.operationSupplierCodeSelection.indexOf({
      supplierCode: yes.itemName,
      isOperationManager: true
    });
    this.operationSupplierCodeSelection.splice(index, 1);
  }

  onSelectAllOperation(yes: any) {
    //console.log("************"+this.roleArray);
    //console.log(this.roleArray.includes("Assembly Operator"));
    if (!this.roleArray.includes("Assembly Operator")) {
      this.deliveryPointlink = [];
      this.itemSelectedDeliveryPoint = [];
    }
    yes.forEach(element => {
      this.itemSelectedOperation.push({ lineNumber: element.itemName });
    });
    this.npdprequired = false;
  }
  onDeSelectAllOperation(yes: any) {
    this.itemSelectedOperation = [];
    this.npdprequired = true;
  }

  onSelectAllDeliveryPoint(yes: any) {
    if (!this.roleArray.includes("Assembly Operator")) {
      this.model.lineNumbers = [];
      this.itemSelectedOperation = [];
    }
    yes.forEach(element => {
      this.itemSelectedDeliveryPoint.push({ deliveryPoint: element.itemName });
    });
    this.npdprequired = false;
  }
  onSelectAllOperationSupplierCode(yes: any) {
    yes.forEach(element => {
      this.operationSupplierCodeSelection.push({
        supplierCode: element.itemName,
        isOperationManager: true
      });
    });
  }

  onDeSelectAllDeliveryPoint(yes: any) {
    this.itemSelectedDeliveryPoint = [];
    this.npdprequired = false;
  }
  onDeSelectAllOperationSupplierCode(yes: any) {
    this.operationSupplierCodeSelection = [];
  }

  onSingleSelectGroupNumber(yes: any) {
    // this.itemSelectedOperation = [];
    this.itemSelectedGroupNumber.push(yes.itemName);
  }
  onDeSelectGroupNumber(yes: any) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedOperation.indexOf(yes.itemName);
    this.itemSelectedGroupNumber.splice(index, 1);
  }

  onSelectAllGroupNumber(yes: any) {
    yes.forEach(element => {
      this.itemSelectedGroupNumber.push(element.itemName);
    });
  }
  onDeSelectAllGroupNumber(yes: any) {
    this.itemSelectedGroupNumber = [];
  }

  onSingleSelect(item: any) {
    this.itemSelected = [];
    this.itemSelected.push({ supplierCode: item.itemName });
  }

  onSingleDeSelect(item: any) {
    this.itemSelected.pop({ supplierCode: item.itemName });
  }

  onItemSelect(item: any) {
    this.itemSelected.push({ supplierCode: item.itemName });
    this.supplierSelected(item.itemName);
    this.supplierCodeReqFlag = false;
  }

  OnItemDeSelect(item: any) {
    let index = this.itemSelected.indexOf({ supplierCode: item.itemName });
    this.itemSelected.splice(index, 1);
    this.operationType === this.operationTypes[0].value &&
    this.itemSelected.length === 0
      ? (this.supplierCodeReqFlag = true)
      : (this.supplierCodeReqFlag = false);
  }
  onSelectAll(items: any) {
    items.forEach(element => {
      this.itemSelected.push({ supplierCode: element.itemName });
    });
    this.supplierCodeReqFlag = false;
  }
  onDeSelectAll(items: any) {
    this.itemSelected = [];
    this.operationType === this.operationTypes[0].value &&
    this.itemSelected.length === 0
      ? (this.supplierCodeReqFlag = true)
      : (this.supplierCodeReqFlag = false);
  }

  onSingleSMQ(yes: any) {
    this.itemSelectedSMQ.push(yes.itemName);

    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectSMQ(yes: any) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedSMQ.indexOf(yes.itemName);
    this.itemSelectedSMQ.splice(index, 1);

    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  onSelectAllSMQ(yes: any) {
    yes.forEach(element => {
      this.itemSelectedSMQ.push(element.itemName);
    });
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectAllSMQ(yes: any) {
    this.itemSelectedSMQ = [];
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  onSingleSMVS(yes: any) {
    this.itemSelectedSMVS.push(yes.itemName);
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectSMVS(yes: any) {
    let index = this.itemSelectedSMVS.indexOf(yes.itemName);
    this.itemSelectedSMVS.splice(index, 1);
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  onSelectAllSMVS(yes: any) {
    yes.forEach(element => {
      this.itemSelectedSMVS.push(element.itemName);
    });
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectAllSMVS(yes: any) {
    this.itemSelectedSMVS = [];
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  onSingleLogistic(yes: any) {
    this.itemSelectedLogistics.push(yes.itemName);
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectLogistic(yes: any) {
    let index = this.itemSelectedLogistics.indexOf(yes.itemName);
    this.itemSelectedLogistics.splice(index, 1);
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  onSelectAllLogistic(yes: any) {
    yes.forEach(element => {
      this.itemSelectedLogistics.push(element.itemName);
    });
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectAllLogistic(yes: any) {
    this.itemSelectedLogistics = [];
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onSingleOM(yes: any) {
    this.itemsSelectedOperations.push(yes.itemName);
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelecOM(yes: any) {
    let index = this.itemsSelectedOperations.indexOf(yes.itemName);
    this.itemsSelectedOperations.splice(index, 1);
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  onSelectAllOM(yes: any) {
    yes.forEach(element => {
      this.itemsSelectedOperations.push(element.itemName);
    });
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }
  onDeSelectAllOM(yes: any) {
    this.itemsSelectedOperations = [];
    //Check the value of multi select dropdown and enable/disable button
    this.checkDDSelected();
  }

  // Operation Role Group Number
  onSingleOPGNo(groupNumber: any) {
    this.featchGroupNumber();
    this.userIDTaken = false;
  }

  onDeSelecOPGNo(yes: any) {
    this.featchGroupNumber();
  }

  onSelectAllOPGNo(yes: any) {
    this.featchGroupNumber();
    this.userIDTaken = false;
  }
  onDeSelectAllOPGNo(yes: any) {
    this.featchGroupNumber();
  }

  featchGroupNumber() {
    let groupid = this.getGroupIds();
    if (groupid.length > 0) {
      if (groupid.length > 0) {
        let suppListNumber = [];
        this.userService.getLineNumberbyGroupNumber(groupid).subscribe(
          data => {
            let res: any;
            res = data;
            suppListNumber = [];
            this.itemSelectedOperation = res.response;

            res.response.forEach(function(value, key) {
              suppListNumber.push({ id: key + 1, itemName: value });
            });

            this.getLineListbyGroupNo = suppListNumber;
            this.model.lineNumbers = suppListNumber;
            this.getSelectedLineNumberByGroup();
            this.spinner.hide();
          },
          error => {
            this.spinner.hide();
          }
        );
        this.checkDDSelected();
      }
    } else {
      this.model.lineNumbers = "";
    }
  }

  getSelectedLineNumberByGroup() {
    let getGroupNoArray = [];
    for (let index = 0; index < this.lineCodeList.length; index++) {
      for (let j = 0; j < this.getLineListbyGroupNo.length; j++) {
        if (
          this.lineCodeList[index].itemName ==
          this.getLineListbyGroupNo[j].itemName
        ) {
          getGroupNoArray.push({
            id: this.lineCodeList[index].id,
            itemName: this.getLineListbyGroupNo[j].itemName
          });
        }
      }
    }
    this.model.lineNumbers = getGroupNoArray;
  }

  postFormError() {
    this.toastr.warning(this.translate.instant("NETWORK_STATUS_ISSUE"));
  }

  registerationSuccess() {
    this.toastr.success(this.translate.instant("REGISTER_SUCCESS"));
    localStorage.removeItem("cacheUser");
  }

  OnRoleItemDeSelect(event) {
    var index1 = this.roleArray.indexOf(event.itemName);
    this.roleArray.splice(index1, 1);
    if (event.itemName === "Operation") {
      this.operationType = "select";
      this.operationTypeDropdown = true;
      this.opTypeRequired = false;
      this.supplierCodeReqFlag = false;
    }
    if (!this.roleArray.includes("Supplier")) {
      if (
        this.roleArray.includes("Operation") &&
        this.operationType === this.operationTypes[0].value
      ) {
        this.supplierCodeReqFlag = true;
        // this.npdprequired = false;
        this.suppliercodeDropdown = false;
      } else {
        this.supplierCodeReqFlag = false;
        // this.npdprequired = true;
        this.suppliercodeDropdown = true;
      }
      this.multiselectDropdown = false;
      this.Suppc = false;
    }

    if (
      !(
        this.roleArray.includes("Operation") ||
        this.roleArray.includes("Assembly Operator")
      )
    ) {
      this.LineN = false;
      this.model.lineNumbers = [];
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
    }
    if (!this.roleArray.includes("Operation")) {
      this.deliveryPointlink = [];
      this.opSupplierCodelink = [];
      this.delPointSuppCodeDropdown = true;
      // this.operationTypeDropdown=true;
    }
    if (
      !(
        this.roleArray.includes("Supplier") ||
        this.roleArray.includes("SMQ") ||
        this.roleArray.includes("Logistic") ||
        this.roleArray.includes("SMVS")
      )
    ) {
      this.model.suppliercode = [];
      this.itemSelected = [];
      this.multiselectDropdown = true;
      if (
        this.roleArray.includes("Operation") &&
        this.operationType === this.operationTypes[0].value
      ) {
        this.supplierCodeReqFlag = true;
        this.npdprequired = false;
        this.suppliercodeDropdown = false;
      } else {
        this.supplierCodeReqFlag = false;
        this.npdprequired = true;
        this.suppliercodeDropdown = true;
      }
    }
  }

  onRoleItemSelect(event) {
    if (
      event.itemName == "Supplier" &&
      (this.roleArray.includes("SMQ") ||
        this.roleArray.includes("Logistic") ||
        this.roleArray.includes("SMVS") ||
        this.roleArray.includes("SMQ"))
    ) {
      this.model.suppliercode = [];
      this.supplierCodeReqFlag = true;
    }
    this.roleArray.push(event.itemName);
    var value = event.itemName;
    this.valueSelected = event.itemName;
    if (value == "Supplier") {
      this.itemSelected = [];
      this.suppCodeList;
      this.Suppc = true;
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      this.l4Selected = false;
      this.suppliercodeDropdown = false;
      this.multiselectDropdown = true;
      //  this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      // this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 1;
      this.roleName = "Supplier";
      this.system = "Mac";
      // Enable save button
      //  this.userIDTaken = false;
    } else if (value == "SMQ") {
      this.itemSelected = [];
      this.suppCodeList;
      //this.Suppc = false;
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      this.l4Selected = false;
      if (!this.roleArray.includes("Supplier")) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = false;
        this.Suppc = false;
      }
      // this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 2;
      this.roleName = "SMQ";
      this.system = "Mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Logistic") {
      this.itemSelected = [];
      this.suppCodeList;
      //this.Suppc = false;
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      this.l4Selected = false;
      if (!this.roleArray.includes("Supplier")) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = false;
        this.Suppc = false;
      }
      // this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 3;
      this.roleName = "Logistic";
      this.system = "Mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Operation") {
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.multiselectDropdown = true;
        this.operationTypeDropdown = false;
        this.Suppc = false;
        this.model.suppliercode = [];
        this.itemSelected = [];
      }

      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.lineCodeList;
      this.groupNumberList;
      // this.Suppc = false;
      this.LineN = true;
      this.l4Selected = false;
      // this.suppliercodeDropdown = true;
      // this.multiselectDropdown = true;
      // this.operationDropdown = false;
      this.operationTypeDropdown = false;
      // this.delPointSuppCodeDropdown = false;
      this.operationGNoDropdown = false;
      this.groupNumberDropdown = true;
      // this.model.suppliercode = [];
      // this.itemSelected = null;
      this.roleId = 4;
      this.roleName = "Operation";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    }
    // else if (value == "Line Worker") {
    //   this.itemSelectedOperation = [];
    //   this.itemSelectedGroupNumber = [];
    //   this.lineCodeList;
    //   this.groupNumberList;
    //   this.Suppc = false;
    //   this.LineN = true;
    //   this.l4Selected = false;
    //   this.suppliercodeDropdown = true;
    //   this.multiselectDropdown = true;
    //   this.operationDropdown = false;
    //   this.operationGNoDropdown = true;
    //   this.groupNumberDropdown = false;
    //   this.model.suppliercode = [];
    //   this.itemSelected = null;
    //   this.roleId = 11;
    //   this.roleName = "Line Worker";
    //   this.system = "mac";
    //   // Enable save button
    //   // this.userIDTaken = false;
    // }
    else if (value == "SMVS") {
      if (!this.roleArray.includes("Supplier")) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = false;
        this.Suppc = false;
      }
      this.itemSelected = [];
      this.suppCodeList;
      //this.Suppc = false;
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      this.l4Selected = false;
      // this.suppliercodeDropdown = true;
      //this.multiselectDropdown = false;
      //  this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      //this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 7;
      this.roleName = "SMVS";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Admin") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = true;
        this.Suppc = false;
        this.suppliercodeDropdown = true;
        //this.model.suppliercode = [];
        //this.itemSelected = null;
      }
      //this.itemSelected = [];
      //this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      //this.Suppc = false;
      //this.LineN = false;
      this.l4Selected = false;
      //this.suppliercodeDropdown = true;
      //this.multiselectDropdown = true;
      //this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      //this.model.suppliercode = [{supplierCode: "ALL"}];
      //this.itemSelected.push({supplierCode: "ALL"});
      // this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 5;
      this.roleName = "Admin";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "SM Admin") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = true;
        this.Suppc = false;
        //this.model.suppliercode = [];
        //this.itemSelected = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      //this.itemSelected = [];
      //this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      //this.Suppc = false;
      //this.LineN = false;
      this.l4Selected = false;
      //this.suppliercodeDropdown = true;
      //  this.multiselectDropdown = true;
      //this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      //this.model.suppliercode = [{supplierCode: "ALL"}];
      //this.itemSelected.push({supplierCode: "ALL"});
      //this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 8;
      this.roleName = "SM admin";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Logistic Admin") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = true;
        this.Suppc = false;
        //this.model.suppliercode = [];
        //this.itemSelected = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      //this.itemSelected = [];
      //this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      //this.Suppc = false;
      //this.LineN = false;
      this.l4Selected = false;
      //this.suppliercodeDropdown = true;
      //this.multiselectDropdown = true;
      //this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      //this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      //this.model.suppliercode = [{supplierCode: "ALL"}];
      //this.itemSelected.push({supplierCode: "ALL"});
      this.roleId = 9;
      this.roleName = "Logistic Admin";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "Assembly Operator") {
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = true;
        this.Suppc = false;
        this.model.suppliercode = [];
        this.itemSelected = [];
        this.npdprequired = true;
      }
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.lineCodeList;
      this.groupNumberList;
      //this.Suppc = false;
      this.LineN = true;
      this.l4Selected = false;
      // this.suppliercodeDropdown = true;
      //this.multiselectDropdown = true;
      this.operationDropdown = false;
      // this.operationTypeDropdown = false;
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = false;
      this.groupNumberDropdown = true;
      // this.model.suppliercode = [];
      // this.itemSelected = null;
      this.roleId = 10;
      this.roleName = "assemblyOperator";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Level-4 Manager") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = true;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.model.suppliercode = [{ supplierCode: "ALL" }];
      this.itemSelected.push("ALL");
      this.roleId = 12;
      this.roleName = "l4Manager";
      this.system = "mac";
      // Disable save button
      // this.userIDTaken = false;
      // this.userIDTaken = false;
    } else if (value == "LSP") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;

      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = true;
        this.multiselectDropdown = true;
        this.Suppc = false;
        //this.model.suppliercode = [];
        //this.itemSelected = null;
      }
      // this.itemSelected = [];
      //this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      //this.Suppc = false;
      //this.LineN = false;
      this.l4Selected = false;
      //this.suppliercodeDropdown = true;
      //this.multiselectDropdown = true;
      //this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      //this.model.suppliercode = [];
      //this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 13;
      this.roleName = "LSP";
      this.system = "mac";
      // Disable save button
      // this.userIDTaken = false;
      // this.userIDTaken = false;
    } else if (value == "Reader") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.LineN = false;
        this.operationDropdown = true;
        this.operationTypeDropdown = true;
        this.itemSelectedOperation = null;
      }
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        // this.suppliercodeDropdown = true;
        this.multiselectDropdown = true;
        this.Suppc = false;
        //this.model.suppliercode = [];
        //this.itemSelected = null;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      //this.itemSelected = [];
      //this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      //this.Suppc = false;
      //this.LineN = false;
      this.l4Selected = false;
      //this.suppliercodeDropdown = true;
      // this.multiselectDropdown = true;
      //this.operationDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      //this.model.suppliercode = [];
      //this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 15;
      this.roleName = "Reader";
      this.system = "mac";
    }
    /*if (this.model.suppliercode) {
      this.model.suppliercode.forEach(element => {
        this.itemSelected.push(element.itemName);
      })
    }*/
  }

  getRolArrayForSelctedRole() {
    let roleObjArray = [];
    this.roleArray.forEach(roledata => {
      let roledataObj = {
        roleId: this.getRoleId(roledata),
        roleName: roledata,
        system: "Mac"
      };
      roleObjArray.push(roledataObj);
    });
    return roleObjArray;
  }

  onOperationTypeSelect(event) {
    // this.operationType = event.target.value;
    if (this.roleArray.includes("Operation")) {
      if (event.target.value === "select" || event.target.value === "") {
        this.opTypeRequired = true;
        this.suppliercodeDropdown = true;
      }
      if (event.target.value === this.operationTypes[1].value) {
        this.opTypeRequired = false;
        if (
          this.roleArray.length === 1 ||
          !(
            this.roleArray.includes("SMQ") ||
            this.roleArray.includes("Logistic") ||
            this.roleArray.includes("SMVS") ||
            this.roleArray.includes("Supplier")
          )
        ) {
          this.suppliercodeDropdown = true;
        }
        this.operationDropdown = false;
        this.delPointSuppCodeDropdown = false;
      }
    }

    if (event.target.value === this.operationTypes[0].value) {
      this.suppliercodeDropdown = false;
      this.opTypeRequired = false;
      if (!this.roleArray.includes("Assembly Operator")) {
        this.operationDropdown = true;
        this.npdprequired = false;
      } else {
        this.npdprequired = true;
      }
      this.delPointSuppCodeDropdown = true;
      this.supplierCodeReqFlag = true;
    }
  }

  onRoleSelectAll(event) {
    event.forEach(item => {
      this.onRoleItemSelect(item);
    });
  }

  onRoleDeSelectAll(event) {
    this.suppliercodeDropdown = true;
    this.multiselectDropdown = false;
    this.Suppc = false;

    this.LineN = false;
    this.model.lineNumbers = [];
    this.operationDropdown = true;
    this.operationTypeDropdown = true;
    this.delPointSuppCodeDropdown = true;
    this.opTypeRequired = false;
    this.npdprequired = false;
    this.model.suppliercode = [];
    this.itemSelected = [];
    this.suppliercodeDropdown = true;
    this.multiselectDropdown = true;
    this.supplierCodeReqFlag = false;
    this.roleArray = [];
  }

  getRoleId(value) {
    switch (value) {
      case "Supplier":
        return 1;
      case "SMQ":
        return 2;
      case "Logistic":
        return 3;
      case "Operation":
        return 4;
      case "Admin":
        return 5;
      case "SMVS":
        return 7;
      case "SM Admin":
        return 8;
      case "Logistic Admin":
        return 9;
      case "Assembly Operator":
        return 10;
      case "Level-4 Manager":
        return 12;
      case "LSP":
        return 13;
      case "Reader":
        return 15;
      default:
        break;
    }
  }

  callType(value) {
    this.valueSelected = value;
    if (value == "Supplier") {
      this.itemSelected = [];
      this.suppCodeList;
      this.Suppc = true;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = false;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 1;
      this.roleName = "Supplier";
      this.system = "Mac";
      // Enable save button
      //  this.userIDTaken = false;
    } else if (value == "SMQ") {
      this.itemSelected = [];
      this.suppCodeList;
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = false;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 2;
      this.roleName = "SMQ";
      this.system = "Mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Logistic") {
      this.suppCodeList;
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = false;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 3;
      this.roleName = "Logistic";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "Operation") {
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.lineCodeList;
      this.groupNumberList;
      this.Suppc = false;
      this.LineN = true;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = false;
      this.operationTypeDropdown = false;
      this.delPointSuppCodeDropdown = false;
      this.operationGNoDropdown = false;
      this.groupNumberDropdown = true;
      this.model.suppliercode = [];
      this.itemSelected = [];
      this.roleId = 4;
      this.roleName = "Operation";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    }
    // else if (value == "Line Worker") {
    //   this.itemSelectedOperation = [];
    //   this.itemSelectedGroupNumber = [];
    //   this.lineCodeList;
    //   this.groupNumberList;
    //   this.Suppc = false;
    //   this.LineN = true;
    //   this.l4Selected = false;
    //   this.suppliercodeDropdown = true;
    //   this.multiselectDropdown = true;
    //   this.operationDropdown = false;
    //   this.operationGNoDropdown = true;
    //   this.groupNumberDropdown = false;
    //   this.model.suppliercode = [];
    //   this.itemSelected = null;
    //   this.roleId = 11;
    //   this.roleName = "Line Worker";
    //   this.system = "mac";
    //   // Enable save button
    //   // this.userIDTaken = false;
    // }
    else if (value == "SMVS") {
      this.itemSelected = [];
      this.suppCodeList;
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = false;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 7;
      this.roleName = "SMVS";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Admin") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.model.suppliercode = [{ supplierCode: "ALL" }];
      this.itemSelected.push({ supplierCode: "ALL" });
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 5;
      this.roleName = "Admin";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "SM Admin") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.model.suppliercode = [{ supplierCode: "ALL" }];
      this.itemSelected.push({ supplierCode: "ALL" });
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 8;
      this.roleName = "SM admin";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Logistic Admin") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.model.suppliercode = [{ supplierCode: "ALL" }];
      this.itemSelected.push({ supplierCode: "ALL" });
      this.roleId = 9;
      this.roleName = "Logistic Admin";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "Assembly Operator") {
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.lineCodeList;
      this.groupNumberList;
      this.Suppc = false;
      this.LineN = true;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = false;
      this.operationTypeDropdown = false;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = false;
      this.groupNumberDropdown = true;
      this.model.suppliercode = [];
      this.itemSelected = [];
      this.roleId = 10;
      this.roleName = "assemblyOperator";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Level-4 Manager") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = true;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.model.suppliercode = ["ALL"];
      this.itemSelected.push("ALL");
      this.roleId = 12;
      this.roleName = "l4Manager";
      this.system = "mac";
      // Disable save button
      // this.userIDTaken = false;
      // this.userIDTaken = false;
    } else if (value == "LSP") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      //if(!this.roleArray.includes("Operation"))
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.model.suppliercode = [];
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 13;
      this.roleName = "LSP";
      this.system = "mac";
      // Disable save button
      // this.userIDTaken = false;
      // this.userIDTaken = false;
    } else if (value == "Reader") {
      this.itemSelected = [];
      this.itemSelectedOperation = [];
      this.itemSelectedGroupNumber = [];
      this.Suppc = false;
      this.LineN = false;
      this.l4Selected = false;
      this.suppliercodeDropdown = true;
      this.multiselectDropdown = true;
      this.operationDropdown = true;
      this.operationTypeDropdown = true;
      this.delPointSuppCodeDropdown = true;
      this.operationGNoDropdown = true;
      this.groupNumberDropdown = true;
      this.model.suppliercode = [];
      this.itemSelectedOperation = null;
      this.itemSelectedGroupNumber = null;
      this.roleId = 15;
      this.roleName = "Reader";
      this.system = "mac";
    }
    if (this.model.suppliercode) {
      this.model.suppliercode.forEach(element => {
        this.itemSelected.push(element.itemName);
      });
    }
  }

  getGroupIds() {
    let itemArray = [];
    if (this.model.operationGroupNumber) {
      for (
        let index = 0;
        index < this.model.operationGroupNumber.length;
        index++
      ) {
        itemArray.push(this.model.operationGroupNumber[index].itemName);
      }
    }
    return itemArray;
  }

  valuechange(newValue) {
    this.model.loginId = newValue;
    if (newValue.length > 0) {
      this.userService.checkexistingLoginID(newValue).subscribe(
        data => {
          console.log(data, newValue);
          // set success message and pass true paramater to persist the message after redirecting to the login page
          if (data.response == "Response is empty") {
            document.getElementById("mytext").innerHTML = " ";
            this.userIDTaken = false;
          } else {
            document.getElementById("mytext").innerHTML =
              "User ID Already Taken";
            this.userIDTaken = true;
          }
        },
        error => {
          this.postFormError();
        }
      );
    } else {
      this.userIDTaken = false;
      document.getElementById("mytext").innerHTML = " ";
    }
  }

  supplierSelected(value) {
    this.selectedSupplier = value;
    if (this.valueSelected == "Supplier") {
      this.userService
        .getSupplierCodeDetail(value[0].itemName)
        .subscribe(result => {
          this.supplierData = result.response;
          this.supplierLoginId = this.supplierData.loginId;
          this.supplierCode = this.supplierData.supplierCode;
          // if (this.supplierLoginId == null) {
          //   this.userIDTaken = false;
          //   // this.supplierError = false
          // } else {
          //   this.userIDTaken = true;
          //   // this.supplierError = true
          // }
        });
    }
  }

  untagDialog() {
    this.displayUntagAlert = true;
  }

  closeLookup() {
    this.displayUntagAlert = false;
  }

  removeNull(value) {
    let arrayList = value.filter(el => el != null);
    return arrayList;
  }

  checkUndefinedOrNull(value) {
    let defaultValue = [];
    if (value)
      return !(
        this.itemSelected.includes(undefined) ||
        this.itemSelected.includes(null)
      )
        ? this.itemSelected
        : this.removeNull(this.itemSelected);
    else return defaultValue;
  }

  register() {
    console.log("test1212121")
    this.spinner.show();

    if (
      this.itemSelectedOperation == null &&
      this.roleArray.includes("Operation")
    ) {
      var itemArray: any = [];
      this.model.lineNumbers.forEach(obj => {
        itemArray.push({ lineNumber: obj.itemName });
      });

      this.itemSelectedOperation = itemArray;
    }

    let registerData = {
      loginId: this.model.loginId,
      password: this.model.password,
      status: "Active",
      loginAttempts: 2,
      employeeId: this.model.employeeId,
      companyName: this.model.companyName,
      firstName: this.model.firstName,
      lastName: this.model.lastName,
      emailId: this.model.emailId,
      phone: this.model.phone,
      operationType: this.operationType,
      //supplierCode: !(this.itemSelected.includes(undefined) || this.itemSelected.includes(null)) ?this.itemSelected: this.removeNull(this.itemSelected),
      supplierCode: this.checkUndefinedOrNull(this.itemSelected),
      lineNumbers: this.itemSelectedOperation ? this.itemSelectedOperation : [],
      deliveryPoint: this.itemSelectedDeliveryPoint
        ? this.itemSelectedDeliveryPoint
        : [],
      groupNumbers: this.itemSelectedGroupNumber,
      supplierManagerQualitys: this.itemSelectedSMQ,
      supplierManagerVendors: this.itemSelectedSMVS,
      operations: this.itemsSelectedOperations,
      logistics: this.itemSelectedLogistics,
      supplierCodeOperation: this.operationSupplierCodeSelection,
      opGroupIds: this.getGroupIds(),
      /*userRoleMappings: 
        { roleId: this.roleId, roleName: this.roleName, system: this.system }
      ,*/
      userRoleMappings: this.getRolArrayForSelctedRole(),
      createBy: this.userDetJson.loginId
    };

    console.log(
      this.npdprequired,
      this.supplierCodeReqFlag,
      this.opTypeRequired
    );
    this.loading = true;
    this.userService.create(registerData).subscribe(
      data => {
        this.spinner.hide();
        // set success message and pass true paramater to persist the message after redirecting to the login page
        this.registerationSuccess();
        this.router.navigate(["/um"]);
      },
      error => {
        this.spinner.hide();
        this.postFormError();
      }
    );
  }

  checkDDSelected() {
    if (
      (this.model.SMQMod != undefined && this.model.SMQMod.length > 0) ||
      (this.model.SMVSMod != undefined && this.model.SMVSMod.length > 0) ||
      (this.model.LogisticMod != undefined &&
        this.model.LogisticMod.length > 0) ||
      (this.model.operationMod != undefined &&
        this.model.operationMod.length > 0)
    ) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function(a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    };
  }
}
